import React from "react";

const SkeletonBonusCard = ({ className = "", variant = "default" }) => {
  // Variant styles match BonusCard variants for consistency
  const variants = {
    default: "text-white",
    welcome: "text-white",
    daily: "text-white",
    vip: "text-white",
  };

  return (
    <div
      className={`relative overflow-hidden rounded-xl shadow-lg bg-background/80 h-full ${variants[variant]} ${className}`}
    >
      {/* Dark overlay to match BonusCard */}
      <div className="absolute inset-0 bg-black/40 rounded-xl"></div>

      {/* Content skeleton */}
      <div className="relative z-10 p-6 h-full flex flex-col justify-between min-h-[200px]">
        <div className="w-[70%] space-y-3">
          <div className="h-3 w-32 bg-card/80 rounded"></div>
          <div className="h-6 w-48 bg-card rounded"></div>
          <div className="h-3 w-56 bg-card/80 rounded"></div>
          <div className="h-3 w-40 bg-card/80 rounded"></div>
        </div>
        <div className="mt-6 h-9 w-28 rounded-md bg-card"></div>
      </div>

      {/* Image silhouette area (bottom-right) */}
      <div className="absolute bottom-0 right-0 w-1/2 max-w-[50%] h-28 md:h-32 bg-card/70 rounded-tl-lg"></div>

      {/* Diagonal shimmer overlay (reuses global animate-shimmer class) */}
      <div className="absolute inset-0 animate-shimmer"></div>
    </div>
  );
};

export default SkeletonBonusCard;
